
import Vue from 'vue';
import MultipleSelectInputField from '@components/new-styleguide/form/MultipleSelectInputField.vue';
import { Component, Prop } from 'vue-property-decorator';
import { MultipleSelectValue } from '@components/new-styleguide/form/MultipleSelectInputField.vue';
import { Zone } from '@clients/myTrips';

@Component({
  name: 'MultipleZoneSelect',
  components: {
    MultipleSelectInputField
  }
})
export default class MultipleZoneSelect extends Vue {
  @Prop()
  private value: Array<Zone>;

  @Prop()
  private zones: Zone[];

  @Prop({ default: false })
  private disabled: boolean;

  get mappedValue() {
    return this.value.map(z => ({
      id: z.id,
      name: z.name
    }))
  }

  get zoneOptions(): MultipleSelectValue[] {
    return this.zones.map(zone => ({
      name: zone.name,
      id: zone.id
    }));
  }

  private handleInput(input: MultipleSelectValue[]) {
    this.$emit('input', Array.from(input.map(select => this.zones.find(z => z.id === select.id))));
  }
}
